module.exports = __webpack_public_path__ + "static/img/events-list-img01.55555f45.png";